<template>
  <el-dialog title="工单派单" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <el-form :model="dispatchHousekeepingInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="dispatchHousekeepingInfo.action == 'BACK' ? '上级处理人' : '工单师傅'" prop="staffId">
        <el-input v-if="dispatchHousekeepingInfo.action == 'BACK'" v-model="dispatchHousekeepingInfo.staffName"
          placeholder="必填，请填写上级处理人" disabled>
        </el-input>
        <el-select v-else v-model="dispatchHousekeepingInfo.staffId" placeholder="必填，请选择工单师傅" style="width:100%">
          <el-option v-for="(item, index) in dispatchHousekeepingInfo.servUsers" :key="index" :label="item.staffName"
            :value="item.staffId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理意见" prop="context">
        <el-input type="textarea" :rows="3" placeholder="必填，请填写处理意见" v-model="dispatchHousekeepingInfo.context">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="_dispatchHousekeepingInfo">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryHousekeepingServUser } from '@/api/housekeeping/housekeepingServUserApi'
import { poolDispatch } from '@/api/housekeeping/housekeepingServPoolApi'
import { getShopId } from '@/api/shop/shopApi'
export default {
  data() {
    return {
      dialogVisible: false,
      dispatchHousekeepingInfo: {
        poolId: '',
        servId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        servUsers: []
      },
      rules: {
        staffId: [
          { required: true, message: '报修师傅不能为空', trigger: 'blur' }
        ],
        context: [
          { required: true, message: '处理意见不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(pool) {
      this.dialogVisible = true
      this.dispatchHousekeepingInfo.shopId = getShopId()
      this.dispatchHousekeepingInfo = {
        ...this.dispatchHousekeepingInfo,
        poolId: pool.poolId,
        servId: pool.servId,
        action: pool.action
      }
      if (pool.action == 'BACK') {
        this.dispatchHousekeepingInfo.staffId = pool.preStaffId
        this.dispatchHousekeepingInfo.staffName = pool.preStaffName
      }
      this._listServUsers()
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.clearDispatchHousekeepingInfo()
    },
    async _dispatchHousekeepingInfo() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.dispatchHousekeepingInfo.action !== 'BACK') {
            const staff = this.dispatchHousekeepingInfo.servUsers.find(
              item => item.staffId === this.dispatchHousekeepingInfo.staffId
            )
            if (staff) {
              this.dispatchHousekeepingInfo.staffName = staff.staffName
            }
          }

          try {
            await poolDispatch(this.dispatchHousekeepingInfo)
            this.$message.success('操作成功')
            this.handleClose()
            this.$emit('refresh')
          } catch (error) {
            console.error('请求失败:', error)
          }
        }
      })
    },
    clearDispatchHousekeepingInfo() {
      this.dispatchHousekeepingInfo = {
        poolId: '',
        servId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        servUsers: []
      }
    },
    async _listServUsers() {
      try {
        const res = await queryHousekeepingServUser({
          page: 1,
          row: 50,
          shopId: getShopId(),
          servId: this.dispatchHousekeepingInfo.servId,
          state: '9999'
        })
        this.dispatchHousekeepingInfo.servUsers = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    }
  }
}
</script>